<ca-conversation-base-list
  [gridId]="gridId"
  [dataSource]="dataSource"
  [gridColumns]="gridColumns"
  [compactPlayer]="compactPlayer"
  (conversationIdChange)="onConversationIdChanged($event)">
</ca-conversation-base-list>
